{
  "wellbore_uwi": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "UWI",
      "width": 175,
    },
  },
  "licensee": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee",
      "isShownByDefault": true,
    },
  },
  "ip3_liquid_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "IP3 Liquid",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "ip12_liquid_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "IP12 Liquid",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "ip3_oil_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "IP3 Oil",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "ip12_oil_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "IP12 Oil",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "ip3_condensate_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "IP3 Condensate",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "ip12_condensate_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "IP12 Condensate",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "ip3_gas_mcf_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mcf/d",
    },
    "ui": {
      "label": "IP3 Gas",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "ip12_gas_mcf_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mcf/d",
    },
    "ui": {
      "label": "IP12 Gas",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "formation": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formation",
      "isShownByDefault": true,
    },
  },
  "field_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field",
      "isShownByDefault": true,
    },
  },
  "well_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Type",
      "isShownByDefault": true,
    },
  },
  "on_prod_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "On Prod Date",
      "width": 125,
      "isShownByDefault": true,
    },
  },
}
